export default __webpack_public_path__ + "static/media/Social_Fb.281f6a71.svg";